import React from 'react'
import { Button as RACButton, ButtonProps } from 'react-aria-components'
import './Button.css'

type Props = {
  asChild?: boolean
  variant?: 'default' | 'icon' | 'primary' | 'negative'
} & ButtonProps

export function Button({ asChild = false, variant = 'default', ...props }: Props) {
  const Comp = asChild ? Slot : RACButton
  return <Comp data-variant={variant} {...props} />
}

function Slot({ children, ...props }: Props) {
  if (React.Children.count(children) > 1) {
    throw new Error('Only one child allowed')
  }

  if (React.isValidElement(children)) {
    return React.cloneElement(children, {
      className: 'react-aria-Button',
      ...props,
      ...children.props,
    })
  }
  return null
}
